import React from "react";
import { RootStateOrAny, useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { panelS } from "../../common/styles/panelStyles";
import { toggleContainersPanel } from "../../../config/redux/container/containersActions";
import ContainerShowForm from "../components/ContainerShowForm";
import ContainerEditForm from "../components/ContainerEditForm";
import { useContainerForm } from "../hooks/useContainerForm";
import { Panel } from "office-ui-fabric-react";
import ContainerRfidHistoryList from "../components/ContainerInternalStoreHistoryList";

const ContainersPanel: React.FC = () => {
    const { t } = useTranslation("admin");
    const dispatch = useDispatch();
    const { containerPanelOpen, isEdit, isShow, isRfidHistory } = useSelector(
        (state: RootStateOrAny) => state.containers
    );

    const dismissPanel = () => {
        dispatch(toggleContainersPanel({ isOpen: false }));
    };

    const { initValues, handleSubmit, cancelForm, loading, gpsDeviceStatuses } = useContainerForm()

    return (
        <Panel
            isOpen={containerPanelOpen}
            closeButtonAriaLabel={t("nav.close") as string}
            headerText={isEdit ? t("nav.panelContainerEdit") as string : isShow ? t("nav.panelContainerDetails") as string : t("nav.panelContainerReadings") as string}
            onDismiss={dismissPanel}
            type={3}
            styles={panelS}
            isHiddenOnDismiss={true}
        >
            {isEdit ?
                <ContainerEditForm
                    initValues={initValues}
                    handleSubmit={handleSubmit}
                    cancelForm={cancelForm}
                    loading={loading}
                    gpsDeviceStatuses= {gpsDeviceStatuses}
                />
                : <></>}
            {isShow ?
                <ContainerShowForm
                    initValues={initValues} />
                : <></>}
            {isRfidHistory ? <ContainerRfidHistoryList/>
                : <></>}
        </Panel>
    );
};

export default ContainersPanel;